import { useCallback } from 'react'

import { MODALS } from '@buffer-mono/app-shell/src/common/types'
import type { ModalData } from '@buffer-mono/app-shell/src/common/events/types'

export { MODALS }
export type { ModalData }

export type OpenGlobalModal = (modal: MODALS, data?: ModalData) => void

/**
 * Opens one of the global modals owned by the app shell.
 *
 * Every publish call site goes through this module, so the modals can move
 * into publish by changing this implementation only.
 *
 * @see MODALS for the modals that can be opened.
 */
export const openGlobalModal: OpenGlobalModal = (modal, data) => {
  window.appshell?.actions?.openModal?.(modal, data)
}

/**
 * Returns a stable {@link openGlobalModal} to use inside React components.
 */
export function useOpenGlobalModal(): OpenGlobalModal {
  return useCallback(openGlobalModal, [])
}
